export const serializeFirebaseData = (data) => {
  if (!data || typeof data !== 'object') {
    return data;
  }

  const serialized = { ...data };

  const timestampFields = ['createdAt', 'updatedAt', 'paidAt', 'timestamp', 'date'];

  timestampFields.forEach(field => {
    if (serialized[field] && serialized[field].toDate) {
      serialized[field] = serialized[field].toDate().toISOString();
    }
  });

  return serialized;
};

export const serializeFirebaseDocuments = (documents) => {
  if (!Array.isArray(documents)) {
    return documents;
  }

  return documents.map(doc => ({
    id: doc.id,
    ...serializeFirebaseData(doc.data ? doc.data() : doc)
  }));
};
